// extracted by mini-css-extract-plugin
module.exports = {"policy":"PrivacyPolicy_policy__1vAip","sameLineTitle":"PrivacyPolicy_sameLineTitle__30ND1"};